import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { DATA_REFRESH_RATE_IN_MILLIS_LONG } from 'src/utils/constants/constants';
import { PricingClient } from 'src/WebApiController';

export const useGetAccountAutoPricingSettings = () => {
  const { activeAccountWebClientConfig } = useAppContext();

  const shouldQuery = useMemo(
    () => activeAccountWebClientConfig.activeAccountId != null,
    [activeAccountWebClientConfig.activeAccountId]
  );
  const pricingSettingsQuery = useQuery({
    queryKey: [
      'PricingClient.getAccountAutoPricingSettings',
      activeAccountWebClientConfig.activeAccountId,
    ],
    queryFn: async () => {
      const pricingSettings = await new PricingClient(
        activeAccountWebClientConfig
      ).getAccountAutoPricingSettings();

      return pricingSettings;
    },

    enabled: shouldQuery,
    staleTime: Infinity,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(500 * attemptIndex, 3000),
    refetchInterval: DATA_REFRESH_RATE_IN_MILLIS_LONG,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    meta: {
      // TODO: temporally hide the error for now, enable this after https://stubhub.enterprise.slack.com/archives/C08D76X6M0S is fixed.
      // onError: (error: ErrorTypes) => {
      //   showErrorDialog('PricingClient.getAccountAutoPricingSettings', error, {
      //     trackErrorData: {
      //       activeAccountId: activeAccountWebClientConfig.activeAccountId,
      //     },
      //   });
      // },
    },
  });

  return {
    pricingSettings: pricingSettingsQuery.data,
    pricingSettingsQuery,
    loaded: pricingSettingsQuery.isFetched,
  };
};
